import algoliasearch from 'algoliasearch';
import instantsearch from 'instantsearch.js';
import customHits from './algolia/hits';
import customSearchBoxHeader from './algolia/searchboxHeader';

let apiIdentifiant = getApiIdentifiant();

if (apiIdentifiant) {
    const searchClient = algoliasearch(apiIdentifiant.appId, apiIdentifiant.apiId);
    const search = instantsearch({
        indexName: getAlgoliaIndex(),
        searchClient,
        searchFunction(helper) {
            if (helper.state.query) {
                helper.search();
            }
        },
    });

    let widgetParameters = [
        customSearchBoxHeader({
            container: document.querySelector('#rechercheHeader'),
            placeholder: getSearchPlaceholder(),
            showSubmit: false,
            cssClasses: {
                root: "",
                form: "barreRecherche-interne form-group",
                input: "form-control"
            }
        }),
        customHits({
            container: document.querySelector('#searchResults'),
            transformItems: (items) => transformItems(items)
        }),
    ];
    search.addWidgets(widgetParameters);
    search.start();
}


/**
 * Retourne les identifiant client APP et API Algolia
 * @return object
 */
function getApiIdentifiant()
{
    let algoliaAppId = $('#rechercheHeader').data('algolia-app-id');
    let algoliaApiId = $('#rechercheHeader').data('algolia-api-id');

    if (algoliaAppId === undefined || algoliaAppId === undefined) return null;

    if (algoliaAppId.length === 0 || algoliaAppId.length === 0) return null;

    return {
        "appId": algoliaAppId,
        "apiId": algoliaApiId
    }
}

/**
 * Retourne le nom de l'index concerné pour la recherche en fonction de la langue de la page
 * @return string
 */
function getAlgoliaIndex()
{
    let langue = $('#rechercheHeader').data('langue');

    if (langue === 'fr') {
        return 'recherche_fr';
    }

    return 'recherche_en';
}

function getSearchPlaceholder()
{
    let searchPlaceholder = $('#rechercheHeader').data('search-placeholder');
    return searchPlaceholder;
}


/**
 * Transforme un item et le retourne transformé
 * @param items 
 * @return newItem
 */
function transformItems(items)
{
    return items.filter((item) => {
        if (item.facette === "produit" && item.particulier === 0) {
            return false;
        }
        return true;
    });

}

